import { Box, Typography, Divider, Link } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LanguageIcon from '@mui/icons-material/Language';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const fontFamily = '"Inter", sans-serif';

const linkStyle = {
  fontFamily,
  fontSize: 13,
  color: '#333',
  fontWeight: 500,
  textDecoration: 'none',
  '&:hover': {
    color: '#0d3c61',
    textDecoration: 'underline',
  },
};

const ProposalViewFooter = ({ techPhone, techEmail }) => {
  // Use tech's info or fallback to defaults
  const phone = techPhone || '619-655-3010';
  const email = techEmail || 'info@airmaxx.com';

  return (
    <Box sx={{ mt: 4, pt: 3 }}>
      <Divider sx={{ mb: 2 }} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 4,
          flexWrap: 'wrap',
          py: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <PhoneIcon sx={{ fontSize: 16, color: '#0d3c61' }} />
          <Link href={`tel:${phone}`} sx={linkStyle}>
            {phone}
          </Link>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <EmailIcon sx={{ fontSize: 16, color: '#0d3c61' }} />
          <Link href={`mailto:${email}`} sx={linkStyle}>
            {email}
          </Link>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <LanguageIcon sx={{ fontSize: 16, color: '#0d3c61' }} />
          <Link href="https://airmaxx.com" target="_blank" rel="noopener noreferrer" sx={linkStyle}>
            airmaxx.com
          </Link>
        </Box>

        <Typography sx={{ fontFamily, fontSize: 13, color: '#333', fontWeight: 500 }}>
          License #915327
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.5 }}>
        <LocationOnIcon sx={{ fontSize: 16, color: '#0d3c61' }} />
        <Typography sx={{ fontFamily, fontSize: 13, color: '#333', fontWeight: 500 }}>
          1865 John Towers Ave, El Cajon, CA 92020
        </Typography>
      </Box>

      <Typography
        sx={{
          fontFamily,
          fontSize: 10,
          color: '#999',
          textAlign: 'center',
          mt: 1,
        }}
      >
        © {new Date().getFullYear()} Airmaxx Inc. All rights reserved.
      </Typography>
    </Box>
  );
};

export default ProposalViewFooter;
